import { CompactUserResponse, UserId, UserResponse } from '../account';
import { BaseResponse, ExtendedFile } from '../common';
import { CompanyId } from '../companies';

export type ProgramId = string;
export type ProjectId = string;
export type SectionId = string;
export type TargetId = string;
export type StepShareId = string;
export type StepCompletedId = string;

export interface AccountResponse {
  companyId: CompanyId;
  title: string;
  appId: string;
}

export interface ProgramSectionResponse extends BaseResponse {
  id: ProgramId;
  title: string;
  programId: ProgramId;
  menuOrder: number;
  steps: ProgramTargetResponse[];
}

export interface ProgramResponse extends BaseResponse {
  id: ProgramId;
  title: string;
  reason: string;
  assignedTo: CompactUserResponse;
  type: string;
  createdAt: number;
  status: ProgramStatus;
  user?: UserResponse;
  author?: UserResponse;
  isAuthor: boolean;
  parentId: string;
  parentName: string;
  canManage: boolean;
  isReport: boolean;
  //   sections: ProgramSectionResponse[];
  //   projects?: ProjectResponse[];
}

export interface ProjectResponse extends BaseResponse {
  id: ProjectId;
  title: string;
  reason: string;
  assignedTo: CompactUserResponse;
  type: string;
  createdAt: number;
  status: ProgramStatus;
  author?: UserResponse;
  parentId: string;
  parentName: string;
  canManage: boolean;
  compliance: boolean;
}

export interface ProgramTargetResponse extends BaseResponse {
  id: TargetId;
  programId: ProgramId;
  sectionId: SectionId;
  title: string;
  createdBy: string;
  menuOrder: string;
  dueDate: number;
  assignees?: [];
  program: CompactProgramsResponse;
  assigneesId: UserId[];
  stepShareUser?: ProgramStepShareResponse[];
  isStepCompleted: boolean;
  completedAt: number;
  project: ProjectResponse;
  submitted: string;
  approved: string;
  rejected: string;
  submittedList: ProgramStepCompletedResponse[];
  rejectedList: ProgramStepCompletedResponse[];
  approvedList: ProgramStepCompletedResponse[];
  totalUsers: string;
  notDone: string;
  stepCompletedData: ProgramStepCompletedResponse;
  canView: boolean;
}

export interface ProgramStepShareResponse extends BaseResponse {
  id: StepShareId;
  stepId: TargetId;
  type: string;
  userId: UserId;
  fullName?: string;
}

export interface ProgramStepCompletedResponse extends BaseResponse {
  id: StepCompletedId;
  stepId: TargetId;
  actionBy: string;
  actionDate: number;
  status: string;
  note: string;
  completedDate: number;
  completedBy: string;
  completedByUser: UserResponse;
  files: ExtendedFile[];
}

export enum ProgramStatus {
  all = -10,
  active = 1,
  archived = 2,
  completed = 3,
}

export const programStatus = [ProgramStatus.all, ProgramStatus.active, ProgramStatus.archived, ProgramStatus.completed];

export interface ProgramSectionResponse extends BaseResponse {
  id: SectionId;
  title: string;
  programId: ProgramId;
  menuOrder: number;
}

export interface ProgramSectionSortingResponse extends BaseResponse {
  id: SectionId;
  menuOrder: number;
  steps: ProgramTargetSortingResponse[];
}

export interface ProgramTargetSortingResponse extends BaseResponse {
  id: SectionId;
  menuOrder: number;
}

export interface ProgramControlBoardItem {
  id: string;
  menuOrder: number;
  title: string;
  cards: ProgramTargetResponse[];
}

export interface ProgramBoardType {
  columns: ProgramControlBoardItem[];
}

export type CompactProgramsResponse = Pick<ProgramResponse, 'id' | 'title' | 'assignedTo' | 'reason' | 'isReport'>;
